import { useEffect, useMemo, useState } from 'react';

import { IMAGE_MODEL_ID_MAP } from '../constants/image';
import { useAppDispatch, useAppSelector } from '../state';
import { queryWebPaintStyle, setCurrStyleName } from '../state/image';

export function useAvatarList() {
  const { modelType } = useAppSelector((state) => state.image);
  const modelId = IMAGE_MODEL_ID_MAP[modelType];
  const avatarStyle = useAppSelector((state) => state.image.modelAvatarStyleMap[modelId]);
  const [currCategoryId, setCurrCategoryId] = useState(0);
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!avatarStyle) {
      dispatch(queryWebPaintStyle({ model_id: modelId }));
    }
  }, [dispatch, modelId, avatarStyle]);
  useEffect(() => {
    setCurrCategoryId(0);
    dispatch(setCurrStyleName(''));
  }, [modelId, dispatch]);

  const { categoryIdStyleMap, categoryList = [] } = avatarStyle || {};
  const avatarStyleList = useMemo(() => {
    return categoryIdStyleMap?.[currCategoryId]?.avatarStyleList || [];
  }, [categoryIdStyleMap, currCategoryId]);
  return { avatarStyleList, categoryList, currCategoryId, setCurrCategoryId };
}
